// extracted by mini-css-extract-plugin
export default {"person":"styles_person__56IB7","photo":"styles_photo__Jzenb","description":"styles_description__ryWMQ","fio":"styles_fio__c7sbx","item":"styles_item__Tu-u5"};